/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query"
import { queryOptions, useQuery } from "@tanstack/react-query"

import fetch from "~/backend/axiosClient"
import type {
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"

import type {
  FindProductStandardValuesQueryResponse,
  FindProductStandardValuesQueryParams,
} from "../types/FindProductStandardValues.ts"

export const findProductStandardValuesQueryKey = (
  params?: FindProductStandardValuesQueryParams
) =>
  [
    { url: "/v1/product/find-product-standard-values" },
    ...(params ? [params] : []),
  ] as const

export type FindProductStandardValuesQueryKey = ReturnType<
  typeof findProductStandardValuesQueryKey
>

/**
 * @summary Find product standard values
 * {@link /v1/product/find-product-standard-values}
 */
export async function findProductStandardValues(
  params?: FindProductStandardValuesQueryParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    FindProductStandardValuesQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: "GET",
    url: `/v1/product/find-product-standard-values`,
    params,
    ...requestConfig,
  })
  return res
}

export function findProductStandardValuesQueryOptions(
  params?: FindProductStandardValuesQueryParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const queryKey = findProductStandardValuesQueryKey(params)
  return queryOptions<
    ResponseConfig<FindProductStandardValuesQueryResponse>,
    ResponseErrorConfig<Error>,
    ResponseConfig<FindProductStandardValuesQueryResponse>,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal
      return findProductStandardValues(params, config)
    },
  })
}

/**
 * @summary Find product standard values
 * {@link /v1/product/find-product-standard-values}
 */
export function useFindProductStandardValues<
  TData = ResponseConfig<FindProductStandardValuesQueryResponse>,
  TQueryData = ResponseConfig<FindProductStandardValuesQueryResponse>,
  TQueryKey extends QueryKey = FindProductStandardValuesQueryKey,
>(
  params?: FindProductStandardValuesQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<FindProductStandardValuesQueryResponse>,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: typeof fetch }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...queryOptions } = queryConfig
  const queryKey =
    queryOptions?.queryKey ?? findProductStandardValuesQueryKey(params)

  const query = useQuery(
    {
      ...findProductStandardValuesQueryOptions(params, config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
